<template>
  <v-dialog v-model="popupData.show" color="white" fullscreen
      transition="dialog-bottom-transition" class="account-details">
    <v-card style="background:white" >
      <v-toolbar fixed flat style="border-radius:0px;background:#fff">
        <v-btn icon @click="onBack()">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-subtitle>
        <div style="color: black; text-align:center;font-size:1.2em; margin-bottom: 2em;">Enter details of the <span style="font-size:1.05em;font-weight: 700;">Bank Account</span> <br/> in which you want to receive money</div>
      </v-card-subtitle>
      <v-card-text>
        <div class="field-row">
          <div class="text-label mandatory">Account Holder's Name</div>
          <v-text-field name="holdersName" placeholder="eg: Ashok Kumar" class="pt-0" regular dense
            v-model="accountHoldersName" type="text">
          </v-text-field>
        </div>
        <div class="field-row">
          <div class="text-label mandatory">Account Number</div>
          <v-text-field name="accountNumber" placeholder="eg: 00000000000" class="pt-0" regular dense v-model="accountNumber"
            type="text">
          </v-text-field>
        </div>
        <div class="field-row">
          <div class="text-label mandatory">IFSC Code</div>
          <v-text-field name="ifsc" placeholder="eg: ICIC000000X" class="pt-0" regular dense v-model="ifsc"
            type="text">
          </v-text-field>
        </div>
        <div class="field-row">
          <div class="text-label mandatory">PAN Number</div>
          <v-text-field name="panNumber" placeholder="eg: ALXXX0000X" class="pt-0" regular dense v-model="panNumber"
            type="text">
          </v-text-field>
        </div>
        <div class="field-row">
          <div class="text-label">GST Number</div>
          <v-text-field name="gstNumber" placeholder="eg: 18XXXXX9603R1ZM" class="pt-0" regular dense v-model="gstNumber"
            type="text">
          </v-text-field>
        </div>
      </v-card-text>  
      <v-card-text class="btn-sty">
        <v-btn block color="error" @click="addAccountDetails()"
        :disabled="!(accountHoldersName && accountNumber && ifsc && panNumber)">Add Details</v-btn>
      </v-card-text>
      
    </v-card>
    <Alert :ref="'alertPopup_' + alertPopup.ref" v-bind:popupData="alertPopup" @closed="alertPopup.show = false"
      v-bind:okText="'CONFIRM'" v-bind:noText="'CANCEL'"
      @ok="save()">
      <v-card-text slot="message" class="alert-sty">
        <div style="margin-bottom: 2em"><span>Verify your details before saving</span></div>
        <div>Account Holder's Name: <span>{{accountHoldersName}}</span></div>
        <div>Account Number: <span>{{accountNumber}}</span></div>
        <div>IFSC Code: <span>{{ifsc}}</span></div>
        <div>PAN Number: <span>{{panNumber}}</span></div>
        <div v-if="gstNumber">GST Number: <span>{{gstNumber}}</span></div>
      </v-card-text>
      
    </Alert>

    <Alert :ref="'backPopup_' + backPopup.ref" v-bind:popupData="backPopup" @closed="backPopup.show = false"
      v-bind:okText="'CONINUE'" v-bind:noText="'GO BACK'"
      @ok="popupData.show = false;$emit('dismissed')">
      <v-card-text slot="message" class="alert-sty">
        <b>You will loose unsaved details on closing this screen</b>
      </v-card-text>
      
    </Alert>
  </v-dialog>

</template>

<style scoped lang="scss">
  .field-row {
    margin-bottom: 1em;
    .text-label {
      font-size: 1em;
      color: black;
      &.mandatory {
        &::after {
          content: '*';
          color: red;
          margin-left: .15em;
        }
      }
    }

    input {
      font-size: .9em  !important;
    }
  }

  .btn-sty {
    position:absolute;
    bottom:2em;
    button {
      background:#f06b69 !important;
      border-color:#f06b69 !important;
      height:3rem !important;
    }
  }

  .alert-sty {
    color: black !important;
    margin-top: 2em;
    div {
      margin-bottom: .5em;
      span {
        font-weight: 700;
      }
    }
  }
</style>

<script>
  //import WIOM_APIS from '../../utils/wiom-apis';
  //import helper from "../../utils/helper";
  import Alert from "../common/Alert";
  export default {
    props: ["popupData"],
     components: {
      Alert
    },
    data: function () {
      return {
        accountHoldersName: '',
        accountNumber: '',
        ifsc: '',
        panNumber: '',
        gstNumber: '',
        accountDetails: null,
        alertPopup: {
          ref: 1,
          show: false,
          message: 'helo'
        },
        backPopup: {
          ref: 1,
          show: false,
        },
      }
    },
    mounted: function() {
      this.accountHoldersName = this.popupData.accountDetails.accountHoldersName;
      this.accountNumber = this.popupData.accountDetails.accountNumber;
      this.ifsc = this.popupData.accountDetails.ifsc;
      this.panNumber = this.popupData.accountDetails.panNumber;
      this.gstNumber = this.popupData.accountDetails.gstNumber;
    },
    methods: {
      addAccountDetails: function() {
        console.log('add acct details')
        let details = {}
        details.accountHoldersName = this.accountHoldersName;
        details.accountNumber = this.accountNumber;
        details.ifsc = this.ifsc;
        details.panNumber = this.panNumber;
        details.gstNumber = this.gstNumber;
        this.accountDetails = details;
        this.alertPopup.show = true;
      },
      save: function() {
        this.$emit('save', this.accountDetails);
        this.alertPopup.show = false;
      },
      onBack: function() {
        if(this.accountHoldersName || this.accountNumber || this.ifsc || this.panNumber) {
          this.backPopup.show = true
        } else {
          this.popupData.show = false;
          this.$emit('dismissed')
        }

      }
    }
  }
</script>